import image from './image';
import model from './model';

import { getField, updateField } from 'vuex-map-fields';

export default {
	namespaced: true,
	state: {
		state: false,
		isModalVisible: false,
		noCheckBox: false,
		onHover: false,
		isDisplayList: false,
	},

	modules: {
		image,
		model
	},

	actions: {
		showFormModal({ commit }) {
			commit('showModal');
		},
		hideFormModal({ commit }) {
			commit('hideModal');
		},
	},
	mutations: {
		showModal(state) {
			state.isModalVisible = true;
		},
		hideModal(state) {
			state.isModalVisible = false;
		},
		
		UPDATE_NO_CHECKBOX(state, payload) {
			state.noCheckBox = payload;
		},
		
		SET_HOVER(state, payload) {
			state.onHover = payload;
		},

		SET_IS_DISPLAY_LIST(state,payload) {
			state.isDisplayList = payload
		},
		updateField,
	},
	getters: {
		getField,

	},

};
